import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormTextarea
} from '@coreui/react-pro'
import '../../../css/FormInvoicingTermsCondition.css'
import FormCheckboxInput from './FormCheckboxInput'
import FormFileUpload from './FormFileUpload'
import FormFileThumbnail from './FormFileThumbnail'

const INVOICE_TERMS = [
  { id: 'terms_invoice',         label: 'Invoice' },
  { id: 'terms_bast',            label: 'Berita Acara Serah Terima' },
  { id: 'terms_po',              label: 'Purchase Order (PO)' },
  { id: 'terms_faktur_pajak',    label: 'Faktur Pajak' },
  { id: 'terms_pkp',             label: 'Surat Keterangan Perusahaan Kena Pajak (PKP)' },
  { id: 'terms_npwp',            label: 'NPWP' },
  { id: 'terms_progress_report', label: 'Laporan Progress Pekerjaan' },
]

const FormInvoicingTermsCondition = ({
  type,
  colSize,
  className,
  inputLabel,
  value,
  handleCheck,
  handleTextInput,
  disabled,
  isDetail = false,
  isShowMultipleUpload = false,
  handleFileInput,
  handleFileOnDrop,
  handleViewFile,
  handleConfirmDelete,
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel className='fw-semibold'>
          {inputLabel} :
        </CFormLabel>
      )}

      {/* Checkbox List */}
      <div
        style={{
          border: '1px solid #d8dbe0',
          borderRadius: '8px',
          padding: '10px 14px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          backgroundColor: '#fbfbfb'
        }}
        className={`terms-condition-scope ${disabled || isDetail ? 'is-disabled' : ''}`}
      >
        {INVOICE_TERMS.map((term) => (
          <FormCheckboxInput
            key={term.id}
            id={term.id}
            name={term.id}
            type={type}
            label={term.label}
            handleCheck={handleCheck}
            disabled={disabled || isDetail}
            value={value?.[term.id]}
            className='fs-6 fs-md-4'
          />
        ))}

        {/* Divider */}
        <hr style={{ margin: '4px 0', borderColor: '#d8dbe0' }} />

        {/* Additional Information inline */}
        <div>
          <CFormLabel
            htmlFor='terms_additional_info'
            className='text-muted mb-1'
            style={{ fontSize: '0.8rem' }}
          >
            Additional Information (opsional)
          </CFormLabel>
          {
            isDetail ? (
              <p className='text-muted mb-0' style={{ fontSize: '0.875rem' }}>
                {value?.terms_additional_info ? value?.terms_additional_info : '-'}
              </p>
            ) : (
              <CFormTextarea
                id='terms_additional_info'
                name='terms_additional_info'
                rows={3}
                placeholder='Enter additional information...'
                value={value?.terms_additional_info || ''}
                onChange={handleTextInput}
                disabled={disabled}
                style={{ fontSize: '0.875rem', resize: 'vertical' }}
              />
            )
          }
        </div>

        {/* Show multiple upload if isShowMultipleUpload is true */}
        {isShowMultipleUpload ? (
          value?.file_document_submission?.length > 0 ? (
            <CCol lg={12}>
              <CFormLabel>
                Attachments
              </CFormLabel>
              <FormFileThumbnail 
                name='file_document_submission'
                colSize='4'
                files={value?.file_document_submission || []}
                className='justify-content-start align-items-center mb-3'
                handleViewFile={handleViewFile}
                handleConfirmDelete={handleConfirmDelete}
                disabled={disabled || isDetail}
                isDetailPage={isDetail}
              />
            </CCol>
          ) : (
            <FormFileUpload
              name='file_document_submission'
              inputLabel='Attachments'
              value={value?.file_document_submission || []}
              handleFileInput={handleFileInput}
              handleFileOnDrop={handleFileOnDrop}
              invalid={false}
              feedbackInvalid=''
              multiple={true}
              accept='.jpg .jpeg, .png, .pdf .docx .doc .xlsx .xls'
              colSize={6}
              className='mt-3'
              disabled={disabled || isDetail}
            />
          )
        ): null}
      </div>
    </CCol>
  )
}

export default FormInvoicingTermsCondition
